import React from 'react';
import { FaFileAlt } from 'react-icons/fa';
import YearSelector from '../../components/common/YearSelector';
import DeclaracionesJuradasTab from '../../components/DeclaracionRenta/DeclaracionesJuradasTab';
import useYearSelector from '../../hooks/useYearSelector';
import useDeclaracionesJuradas from '../../hooks/useDeclaracionesJuradas';
import '../../styles/pages/ServiciosSII/DeclaracionesJuradasPage.css';

const DeclaracionesJuradasPage = ({ token, id_company, rut_empresa }) => {
    const {
        selectedYear,
        setSelectedYear,
        yearOptions
    } = useYearSelector(null, 5, 1);

    const {
        declaracionesJuradas,
        loading,
        createDeclaracionJurada,
        updateDeclaracionJurada,
        deleteDeclaracionJurada
    } = useDeclaracionesJuradas(selectedYear, id_company, token);

    return (
        <div className="declaraciones-juradas-page">
            <div className="page-header">
                <div className="header-content">
                    <div className="title-section">
                        <FaFileAlt className="page-icon" />
                        <div>
                            <h1>Declaraciones Juradas</h1>
                            <p className="page-subtitle">
                                Gestión de declaraciones juradas anuales
                            </p>
                        </div>
                    </div>
                    <YearSelector
                        selectedYear={selectedYear}
                        onYearChange={setSelectedYear}
                        yearOptions={yearOptions}
                        label="Año Tributario"
                        className="header-year-selector"
                    />
                </div>
            </div>

            <div className="dj-content">
                <DeclaracionesJuradasTab
                    declaraciones={declaracionesJuradas}
                    selectedYear={selectedYear}
                    loading={loading}
                    onCreate={createDeclaracionJurada}
                    onUpdate={updateDeclaracionJurada}
                    onDelete={deleteDeclaracionJurada}
                    token={token}
                    idCompany={id_company}
                    rutEmpresa={rut_empresa}
                />
            </div>

            <div className="page-footer">
                <p className="footer-info">
                    <strong>Nota:</strong> Las declaraciones juradas deben ser presentadas ante el SII
                    en los plazos establecidos para cada tipo de declaración.
                </p>
            </div>
        </div>
    );
};

export default DeclaracionesJuradasPage;
